'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../helpers/utils');

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  var title = props.title,
      className = props.className,
      href = props.href,
      action = props.action,
      disabled = props.disabled,
      hideTitle = props.hideTitle,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      newWindow = props.newWindow,
      elementRef = props.elementRef,
      small = props.small,
      type = props.type,
      width = props.width;


  var newProps = {
    className: (0, _utils.classNames)('Button', [className, type, width], { hideTitle: hideTitle, iconLeft: iconLeft, iconRight: iconRight, small: small })
  };

  if (elementRef) {
    newProps.ref = elementRef;
  }

  if (hideTitle) {
    newProps['aria-label'] = title;
    newProps.title = title;
  }

  var content = _react2.default.createElement(
    'span',
    null,
    iconLeft && _react2.default.createElement(_.Icon, { name: iconLeft }),
    !hideTitle && title,
    iconRight && _react2.default.createElement(_.Icon, { name: iconRight })
  );

  if (href) {
    if (newWindow) {
      newProps.target = '_blank';
      newProps.rel = 'noopener noreferrer';
    }
    return _react2.default.createElement(
      'a',
      (0, _extends3.default)({ href: href }, newProps),
      content
    );
  }

  return _react2.default.createElement(
    'button',
    (0, _extends3.default)({ onClick: action, disabled: disabled }, newProps),
    content
  );
};

Button.propTypes = {
  /**
   * The title of the button.
   */
  title: _propTypes2.default.string.isRequired,
  /**
   * The CSS class of the block.
   */
  className: _propTypes2.default.string,
  /**
   * URL to link to.
   */
  href: _propTypes2.default.string,
  /**
   * Action triggered when the button is clicked.
   */
  action: _propTypes2.default.func,
  /**
   * Whether the button is disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Whether the title should be hidden (if so, it will still be available to screenreaders)
   */
  hideTitle: _propTypes2.default.bool,
  /**
   * The name of the icon to display on the left side of the button.
   */
  iconLeft: _propTypes2.default.string,
  /**
   * The name of the icon to display on the right side of the button.
   */
  iconRight: _propTypes2.default.string,
  /**
   * Whether to open the link in a new window.
   */
  newWindow: _propTypes2.default.bool,
  /**
   * Passthrough for the ref special prop. https://fb.me/react-special-props
   */
  elementRef: _propTypes2.default.func,
  /**
   * Whether the button has smaller text.
   */
  small: _propTypes2.default.bool,
  /**
   * The button type.
   */
  type: _propTypes2.default.oneOf(['primary', 'secondary', 'borderless']),
  /**
   * The button width.
   */
  width: _propTypes2.default.oneOf(['full', 'fit'])
};

Button.defaultProps = {
  disabled: false,
  type: 'secondary',
  width: 'fit'
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Button.js
// module id = 261
// module chunks = 0